/* global System */
// register component(s) with react habitat

export default { PeopleFilters: () => System.import('./people_filters-data') }
